export function ParseNumberFormat(clipboardText: string): string{
	if (clipboardText){
		return  clipboardText.replace(/[^\d.-]/g, '');
	}

	return clipboardText;
}